<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import { ddlHelper, sessionHelper, sharedHelper } from "@/utils";
import { SESSION } from "@/constants";
import { required } from "vuelidate/lib/validators";
import { mapState } from "vuex";
import i18n from '@/i18n'
import { LOOKUP_MODULE } from '@/state/modules/lookup'
import { PRODUCT_SOURCE_MODULE } from '@/state/modules/productSource'
import { lookupMethods, productSourceMethods } from "@/state/helpers";
import Multiselect from "vue-multiselect";

export default {
    page: {
        title: i18n.t("label.updateX", [i18n.t("module.productSource")]),
    },
    components: { Layout, PageHeader, Multiselect },
    beforeRouteLeave(to, from, next) {
        if (to.name != "Product-source-listing") {
            sessionHelper.clearSearch(SESSION.PRODUCT_SOURCE_SEARCH);
        }
        next();
    },
    computed: {
        ...mapState(PRODUCT_SOURCE_MODULE, ["status"]),
        ...mapState(LOOKUP_MODULE),
        productDdl() {
            return this.$store.state.lookup.productDdl;
        },
        sourceDdl() {
            return this.$store.state.lookup.sourceDdl;
        },
    },
    data() {
        return {
            title: i18n.t("label.createX", [i18n.t("module.productSource")]),
            options: [
                { value: 0, text: 'Pending' },
                { value: 1, text: 'Approved' }
            ],
            items: [
                {
                    text: i18n.t('module.dashboard'),
                    href: "/",
                },
                {
                    text: i18n.t("module.productSource"),
                    href: "/product-source",
                },
                {
                    text: i18n.t("label.createX", [i18n.t("module.productSource")]),
                    active: true,
                },
            ],
            submitted: false,
            statusDdl: ddlHelper.getActivationStatus(false, true),
            selectedOffDays: [], // This will hold the full objects selected in the multiselect
            weekDayDdl: ddlHelper.getWeekDays(),
            permissions: sessionHelper.getPermissions(),
            createPermission: null,
            isCloseWhenSuccess: false, 
            createForm: {
                sourceID: "",
                productID: "",
                remark: "",
            },
        };
    },
    validations: {
        createForm: {
            sourceID: { required },
            productID: { required },
        },
    },
    async created() {
        await this.validPermissions();
        this.searchCriteria = sessionHelper.retrieveSearch(SESSION.PRODUCT_SPECIAL_SEARCH);
        await this.lookupProduct({ hasOptionAll: false });

        if (this.searchCriteria != null) {
            this.createForm.productID = this.$store.state.lookup.productDdl.filter(item => item.value === this.searchCriteria.selectedRecordId);

            if( this.createForm.productID != null && this.createForm.productID.length > 0) {
                this.isCloseWhenSuccess = true; 
            }

            if (this.searchCriteria != null && this.searchCriteria != '' && this.searchCriteria.selectedRecordId == null) {
                sharedHelper.alertErrorMessageWithoutCode("Invalid Product ID, Please Contact Admin")
            }
        }

        this.lookupSource({ hasOptionAll: false });
    },
    methods: {
        ...productSourceMethods,
        ...lookupMethods,
        async validPermissions() {
            var jsonPermissions = JSON.parse(this.permissions)
            if (jsonPermissions.some(p => p.code === "RND_PS_PSC")) {
                this.createPermission = true;
            }
            else {
                this.createPermission = false;
            }
        },
        async requestCreate() {
            this.submitted = true;
            // stop here if form is invalid
            this.$v.$touch();

            if (this.$v.$invalid) {
                return;
            } else {
                let isCloseWhenSuccess = this.isCloseWhenSuccess;
                let data = {
                    sourceID: this.createForm.sourceID.value,
                    productID: this.isCloseWhenSuccess == true ? this.createForm.productID[0].value : this.createForm.productID.value,
                    remark: this.createForm.remark,
                };

                if (this.createPermission == true) {
                    await this.createProductSource({ data, isCloseWhenSuccess });
                }
            }
        },
    },
};
</script>

<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <div class="row">
            <div class="col">
                <div class="card">
                    <div class="card-body">
                        <form @submit.prevent="requestCreate" v-if="createPermission == true">
                            <div class="row">
                                <div class="col-md-6">
                                    <b-form-group id="productID" label-cols-sm="4" label-cols-lg="4"
                                        :label="$t('module.product')" label-for="productID">
                                        <multiselect v-model="createForm.productID"
                                            deselect-label="Can't remove this value" track-by="value" label="text"
                                            placeholder="Select one" :options="productDdl" :searchable="true"
                                            :allow-empty="false">
                                        </multiselect>
                                        <div v-if="submitted && !$v.createForm.productID.required"
                                            class="invalid-feedback" style="display: block;">
                                            <span>{{ $t("message.requiredX", [$t("module.product")]) }}</span>
                                        </div>
                                    </b-form-group>
                                </div>
                                <div class="col-md-6">
                                    <b-form-group id="sourceID" label-cols-sm="4" label-cols-lg="4"
                                        :label="$t('module.source')" label-for="sourceID">
                                        <multiselect v-model="createForm.sourceID"
                                            deselect-label="Can't remove this value" track-by="value" label="text"
                                            placeholder="Select one" :options="sourceDdl" :searchable="true"
                                            :allow-empty="false">
                                        </multiselect>
                                        <div v-if="submitted && !$v.createForm.sourceID.required"
                                            class="invalid-feedback" style="display: block;">
                                            <span>{{ $t("message.requiredX", [$t("module.source")]) }}</span>
                                        </div>
                                    </b-form-group>
                                </div>

                                <div class="col-md-6">
                                    <b-form-group id="remark" label-cols-sm="4" label-cols-lg="4"
                                        :label="$t('label.remark')" label-for="remark">
                                        <textarea v-model="createForm.remark" class="form-control" name="textarea"
                                            rows="5"></textarea>
                                    </b-form-group>
                                </div>

                            </div>

                            <div class="mt-4 text-center" style="float: right">
                                <button class="btn btn-primary w-md waves-effect waves-light" style="margin-right: 10px"
                                    type="submit" :disabled="status.create">
                                    {{ $t("label.createX", [$t("module.productSource")]) }}
                                </button>
                            </div>
                        </form>
                        <div style="text-align: center;" v-else>
                            {{ $t('message.noPermissionMessage') }}
                        </div>
                    </div>
                </div>
                <!-- end card -->
            </div>
            <!-- end col -->
        </div>
    </Layout>
</template>